import { ref } from '@vue/composition-api';

import usePermissionByAccount from "@/constants/navigation/BOYNYKJMS2EH/permission-by-account"

export default function useReport() {
  const { getPermissionModule } = usePermissionByAccount()
  const stepActive = ref(0);

  const onNextStep = () => {
    stepActive.value = 1;
  };

  return { stepActive, onNextStep, getPermissionModule };
}
